/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Remove_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to delete style guide:" |
*
* @param {Style_Guide_Manager_Remove_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_remove_failed_toast = /** @type {((inputs?: Style_Guide_Manager_Remove_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Remove_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec de la suppression du guide de style :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Löschen des Styleguides:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile eliminare la guida di stile:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось удалить руководство по стилю:")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo eliminar la guía de estilo:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除样式指南失败：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイル ガイドの削除に失敗しました:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड को हटाने में विफलता:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao excluir o guia de estilo:")
	return /** @type {LocalizedString} */ ("Failed to delete style guide:")
});